import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import FeedbackHelp from '../feedbackHelp';

import { setSaving, setVideoPosition } from 'actions/ui';
import { Copy, DeleteWarning, Forms, Help, SaveButton, SystemText } from 'e4shared';
import Rating from 'components/general/rating';

export const TaskFeedbackSection = ({
    task,
    user,
    downline,
    clearShowSuccess,
    showSuccess,
    goalMet,
    feedback_1,
    feedback_2,
    feedback_3,
    rating,
    competencies,
    setGoalMet,
    setFeedback1,
    setFeedback2,
    setFeedback3,
    setRating,
    saveFeedback,
    canSubmitFeedback,
    showFeedbackError,
    submitDisabled,
}) => {
    const dispatch = useDispatch();

    const { saving, tags, handles } = useSelector(state => state.ui);

    const [showDelete, setShowDelete] = React.useState(false);

    const dispatchSetVideoPosition = position => dispatch(setVideoPosition(position));

    const st = (path, ...rest) => SystemText(`Objective/Feedback/${path}`, ...rest);

    React.useEffect(() => {
        const buttons = [...document.getElementsByClassName('btn-time')];
        buttons.forEach(btn => {
            btn.addEventListener('click', event => {
                const time = btn.getAttribute('data-time').split(':');
                const secs = parseInt(time[0], 10) * 60 + parseInt(time[1], 10);
                dispatchSetVideoPosition(secs);
                event.stopPropagation();
            });
        });
    }, []);

    if (!task.requires_Manager || !task.date_Completed) return null;

    const isUser = task.profile_Id === user.id;

    const notManagerSecton = (
        <div className="form-group">
            <div className="user-comment italic">{st('AwaitingManager')}</div>
        </div>
    );

    const approvedShowSuccessSection = (
        <div className="form-group">
            <div>
                <i className="fa fa-check-circle text-success mr10" />
                {st('Approved')}
            </div>
            <button className="btn btn-default mt20" onClick={() => clearShowSuccess?.()}>
                {st('Review')}
            </button>
        </div>
    );

    const rejectedShowSuccessSection = (
        <div className="form-group">
            <div>
                <i className="fa fa-cross-circle text-red mr10" />
                {st('Returned')}
            </div>
            <button className="btn btn-default mt20" onClick={() => clearShowSuccess?.()}>
                {st('Review')}
            </button>
        </div>
    );

    const setTimes = text => {
        if (!task.video) return text;
        const re = /(\[)([0-1]?[0-9]:[0-5][0-9])(\])/g;
        text = text.replace(re, `[<button data-time="$2" class="btn btn-link btn-time">$2</button>]`);
        return text;
    };

    const approvedSection = (
        <div className="form-group">
            <div className="user-comment">
                <div>
                    {task.feedback_From > 0 && (
                        <div>
                            <label>{st('ApprovedBy')}</label>
                            <div className="mb10">
                                <Link to={`/search/${task.feedback_From_Fullname}`}>
                                    <span>{task.feedback_From_Fullname}</span>
                                </Link>
                            </div>
                        </div>
                    )}
                    {task.metric_Task && (
                        <div>
                            <label>{st('GoalMet')}</label>
                            <div className="mb10">{goalMet ? st('GoalMet/Yes') : st('GoalMet/No')}</div>
                        </div>
                    )}
                    {task.requires_Feedback && (
                        <>
                            <div>
                                <div>
                                    <label>{st('Worked')}</label>
                                    <div className="mb10">
                                        {feedback_1 ? <Copy value={feedback_1} extraFormatting={setTimes} /> : '-'}
                                    </div>
                                </div>
                                <div>
                                    <label>{st('NotWorked')}</label>
                                    <div className="mb10">
                                        {feedback_2 ? <Copy value={feedback_2} extraFormatting={setTimes} /> : '-'}
                                    </div>
                                </div>
                                <div>
                                    <label>{st('Missing')}</label>
                                    <div className="mb10">
                                        {feedback_3 ? <Copy value={feedback_3} extraFormatting={setTimes} /> : '-'}
                                    </div>
                                </div>
                            </div>
                            {task.competency_Ids?.length && task.competencies?.length ? (
                                <div>
                                    <label>{st('Ratings')}</label>
                                    {task.competencies.map(c => {
                                        return (
                                            <div key={`rating-${c.id}`} className="flex flex-row">
                                                <div className="mr10 ">
                                                    {`${c.area} - ${c.name}`}
                                                    {c.description && <Help id={`competency-${c.id}`}>{c.description}</Help>}
                                                </div>
                                                <Rating hideLabel smallStar value={c.rating} />
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <Rating value={task.rating} />
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );

    const showSuccessSection = (
        <div className="form-group">
            <div>
                <i className="fa fa-check-circle text-success mr10" />
                {st('Success')}
            </div>
            <button className="btn btn-default mt20" onClick={() => clearShowSuccess?.()}>
                {st('Continue')}
            </button>
        </div>
    );

    const editSection = (
        <div>
            <div className="form-group ">
                {task.metric_Task && (
                    <div className="mb10 mtm10">
                        <Forms.Toggle
                            label={st('Achieved/Label', task.assigned_Fullname)}
                            help={st('Achieved/Help')}
                            value={goalMet}
                            onChange={setGoalMet}
                        />
                    </div>
                )}
                {task.requires_Feedback && (
                    <>
                        <div>
                            <label>
                                {st('Feedback/Manager')} {task.requires_Manager && <span className="mandatory">*</span>}
                            </label>
                            <p>
                                {st('Review/Above')} {task.requires_Feedback ? st('Review/Mandatory') : ''}
                                <FeedbackHelp />
                            </p>
                            <Forms.Textarea
                                tags={tags}
                                handles={handles}
                                id="manager-feedback"
                                className="form-control mb10"
                                rows="2"
                                value={feedback_1}
                                onChange={setFeedback1}
                                placeholder={st('Worked')}
                            />
                            <Forms.Textarea
                                tags={tags}
                                handles={handles}
                                rows="2"
                                className="form-control mb10"
                                value={feedback_2}
                                onChange={setFeedback2}
                                placeholder={st('NotWorked')}
                            />
                            <Forms.Textarea
                                tags={tags}
                                handles={handles}
                                rows="2"
                                className="form-control mb10"
                                value={feedback_3}
                                onChange={setFeedback3}
                                placeholder={st('Missing')}
                            />
                        </div>

                        {task.competency_Ids?.length && task.competencies?.length > 0 ? (
                            <div>
                                <label>
                                    {st('Ratings')} {task.requires_Manager && <span className="mandatory">*</span>}
                                </label>
                                {task.competencies.map(c => {
                                    const compRating = competencies.filter(x => x.id === c.id);
                                    const rating = compRating && compRating.length > 0 ? compRating[0].rating : c.rating;
                                    return (
                                        <div key={`rating-${c.id}`} className="flex flex-row">
                                            <div className="mr10 ">
                                                {`${c.area} - ${c.name}`}{' '}
                                                {c.description && <Help id={`competency-${c.id}`}>{c.description}</Help>}
                                            </div>
                                            <div className="mb10">
                                                <Rating
                                                    hideLabel
                                                    smallStar
                                                    value={rating}
                                                    onChange={r => setRating(r, c.id)}
                                                />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="mb10">
                                <Rating value={task.rating || rating} onChange={r => setRating(r)} />
                            </div>
                        )}

                        {showFeedbackError && submitDisabled && (
                            <div className="text-red mb10">{st('Ratings/Mandatory')}</div>
                        )}
                    </>
                )}
            </div>
        </div>
    );

    if (task.approved && showSuccess && !isUser) {
        return approvedShowSuccessSection;
    }

    if (task.rejected && task.rejected.length > 0 && showSuccess && !isUser) {
        return rejectedShowSuccessSection;
    }

    if (task.approved) {
        return approvedSection;
    }

    if (task.date_Completed && !canSubmitFeedback) {
        return notManagerSecton;
    }

    return showSuccess ? showSuccessSection : editSection;
};

export default TaskFeedbackSection;
